import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.86054 -4.40122e-05L9.86418 0.00359545V8.62341H16.3671V10.6234H9.86418V19.5255L9.86054 19.529L-5.98735e-06 9.76457L9.86054 -4.40122e-05ZM20.1394 10.133L20.1358 10.1366V19.0387H13.3912V21.0387H20.1358V29.6585L20.1394 29.6621L30 19.8976L20.1394 10.133Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }